import { formatCurrency } from '@/helpers/currency';
import type { DateOptions, DateValue, WeekDayValue } from '@/helpers/dates';
import {
  formatDate,
  formatWeekDay,
  fromNow,
  ordinalDate,
} from '@/helpers/dates';
import {
  capitalize,
  formatEnters,
  giftCardCode,
  plaintextToHtml,
  stripHtml,
} from '@/helpers/formatting';
import type { Currency } from '@/types';

export default {
  currency: (value: number, currency?: Currency) =>
    formatCurrency(value, currency),

  date: (value: DateValue, options?: DateOptions) => formatDate(value, options),
  time: (value: DateValue) => formatDate(value, { format: 'time' }),
  dateTime: (value: DateValue) =>
    formatDate(value, { format: 'numeric', addTime: true }),
  // Readable weekday format, e.g. "Wed, Sep 09, 2026 - 11:00" (matches the date picker).
  dateTimeLong: (value: DateValue) =>
    formatDate(value, { format: 'datePicker', addTime: true }),

  monthLong: (value: DateValue) => formatDate(value, { format: 'monthLong' }),
  monthShort: (value: DateValue) => formatDate(value, { format: 'monthShort' }),

  weekdayNarrow: (dayOfWeek: WeekDayValue) =>
    formatWeekDay(dayOfWeek, 'weekdayNarrow'),
  weekdayShort: (dayOfWeek: WeekDayValue) =>
    formatWeekDay(dayOfWeek, 'weekdayShort'),
  weekdayLong: (dayOfWeek: WeekDayValue) =>
    formatWeekDay(dayOfWeek, 'weekdayLong'),

  ordinalDate: (number: number) => ordinalDate(number),
  fromNow: (value: DateValue) => fromNow(value),

  formatEnters: (value: string) => formatEnters(value),
  giftCardCode: (value: string) => giftCardCode(value),
  capitalize: (value: string) => capitalize(value),
  plaintextToHtml: (value: string) => plaintextToHtml(value),
  stripHtml: (value: string) => stripHtml(value),
};
